import * as React from "react"
import { ModalSeeker, ButtonSeeker } from "ui-seeker/core"

export default function ConfirmModal({ isOpen, onClose, onConfirm, hotelName }) {
    return <ModalSeeker
        isOpen={isOpen}
        controller={onClose}
        title="Change Main Hotel"
        okBtn={false}
        cancelBtn={false}
    >
        <div style={{ padding: '16px 0' }}>
            <p style={{ marginBottom: '16px' }}>
                Are you sure you want to set <strong>{hotelName}</strong> as the main hotel?
            </p>
            <p style={{ marginBottom: '24px', color: '#666', fontSize: '13px' }}>
                All price comparisons and calculations will be recalculated using this hotel as the reference.
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <ButtonSeeker variant="outlined" onClick={onClose}>
                    Cancel
                </ButtonSeeker>
                <ButtonSeeker variant="contained" color="primary" onClick={onConfirm}>
                    Confirm
                </ButtonSeeker>
            </div>
        </div>
    </ModalSeeker>
}
